import { render, staticRenderFns } from "./TeamAgency.vue?vue&type=template&id=79a182f2&"
import script from "./TeamAgency.vue?vue&type=script&lang=js&"
export * from "./TeamAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports